import { subDays } from 'date-fns';

export const getPastDays = (difference?: number, from: Date = new Date()) => {
  from.setUTCHours(0, 0, 0, 0);
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const endDate = subDays(new Date(from || today), difference || 0);
  return endDate;
};
